/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPilcrowRight = createReactComponent("outline", "pilcrow-right", "IconPilcrowRight", [["path", { "d": "M11 9h-2a3 3 0 1 1 0 -6h7", "key": "svg-0" }], ["path", { "d": "M11 3v11", "key": "svg-1" }], ["path", { "d": "M15 3v11", "key": "svg-2" }], ["path", { "d": "M21 18h-18", "key": "svg-3" }], ["path", { "d": "M18 15l3 3l-3 3", "key": "svg-4" }]]);

export { IconPilcrowRight as default };
//# sourceMappingURL=IconPilcrowRight.mjs.map
